import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect, useMemo } from 'react';
import { useScript } from 'usehooks-ts';

declare global {
  interface Window {
    Beacon?: {
      // oxlint-disable-next-line typescript/no-explicit-any -- Untyped Helpscout beacon object
      (e: string, n?: any, d?: any): void;
      // oxlint-disable-next-line typescript/no-explicit-any -- Untyped Helpscout beacon object
      readyQueue?: Array<{ method: string; options?: any; data?: any }>;
    };
  }
}

export function useHelpscoutBeacon(isEndConsumer: boolean) {
  const { isAuthenticated } = useAuth0();

  // prevents load of beacon entirely when:
  // - it's localhost
  // - user is not authenticated
  // - user is an end consumer
  const shouldPreventLoad = useMemo(
    () => window.location.hostname === 'localhost' || !isAuthenticated || isEndConsumer,
    [isAuthenticated, isEndConsumer],
  );

  useScript('https://beacon-v2.helpscout.net', {
    shouldPreventLoad,
  });

  const toggleChat = useCallback(() => {
    window.Beacon?.('toggle');
  }, []);

  useEffect(() => {
    if (shouldPreventLoad) {
      window.Beacon?.('destroy');
      window.Beacon = undefined;
      return;
    }

    if (!window.Beacon) {
      // oxlint-disable-next-line typescript/no-explicit-any -- Untype helpscout function
      window.Beacon = (e: string, n: any, d: any) => {
        window.Beacon?.readyQueue?.push({ data: d, method: e, options: n });
      };
      window.Beacon.readyQueue = [];

      window.Beacon?.('init', 'f99bd06a-db48-459d-b2a6-272596c5edf2');
    }
  }, [shouldPreventLoad]);

  return { toggleChat };
}
